export default "__VITE_ASSET__q6mUG_c9__"